<template>
  <div class="animated fadeIn">
    <component :entity="entity" :http="http" :is="entity.indexComponent" :card="true">
      <div slot="header" class="row">
        <div class="col">
          <h1 v-if="entity.name" slot="header">
            {{ entity.name }}
          </h1>
        </div>

        <div class="col">
          <router-link :to="createRoute" v-if="entity.add !== false">
            <label class="btn btn-primary float-right" style="margin: 4px 0px 0px;">
              <i class="fa fa-plus mr-1"></i> Incluir
            </label>
          </router-link>

          <a :href="entity.order" v-if="entity.order">
            <label class="btn btn-secondary float-right" style="margin: 4px;">
              <i class="fa fa-sort mr-1"></i> Ordernar
            </label>
          </a>

          <template v-if="entity.indexButtons && entity.indexButtons.length > 0"
            v-for="(button, index) in entity.indexButtons">
            <component :key="`custom-button-index-${index}`"
              :entity="entity"
              :http="http"
              :is="button"></component>
          </template>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
  export default {
    props: {
      http: {
        type: Object,
        required: true
      },

      entity: {
        type: Object,
        required: true
      }
    },

    computed: {
      createRoute () {
        return {
          name: 'manageables.create',
          params: {
            entity: this.entity.key
          }
        }
      },
      orderRoute () {
        return {
          name: this.entity.order,
          params: {
            entity: this.entity.key
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/manageables/Index.vue